
export default {
  data: () => ({
    loading: false,
    progress: 0
  }),
  methods: {
    start() {
      this.loading = true
      this.$store.commit('setLoading', { data: true })
    },
    finish() {
      this.progress = 100
      this.$store.commit('setLoading', { data: false })
      setTimeout(() => {
        this.loading = false
      }, 250)
    },
    increase(num) {
      this.progress = num
    }
  }
}
